// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IServiceLiteWithCategoryTypeDto } from './IServiceLiteWithCategoryTypeDto';
import {
    IServiceLiteWithCategoryTypeDtoFromJSON,
    IServiceLiteWithCategoryTypeDtoFromJSONTyped,
    IServiceLiteWithCategoryTypeDtoToJSON,
    IServiceLiteWithCategoryTypeDtoToJSONTyped,
} from './IServiceLiteWithCategoryTypeDto';
import type { IPaymentRuleDto } from './IPaymentRuleDto';
import {
    IPaymentRuleDtoFromJSON,
    IPaymentRuleDtoFromJSONTyped,
    IPaymentRuleDtoToJSON,
    IPaymentRuleDtoToJSONTyped,
} from './IPaymentRuleDto';

/**
 * 
 * @export
 * @interface IServiceConfigDto
 */
export interface IServiceConfigDto {
    /**
     * 
     * @type {number}
     * @memberof IServiceConfigDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IServiceConfigDto
     * @deprecated
     */
    service_id?: number;
    /**
     * 
     * @type {IServiceLiteWithCategoryTypeDto}
     * @memberof IServiceConfigDto
     */
    service?: IServiceLiteWithCategoryTypeDto;
    /**
     * 
     * @type {Set<number>}
     * @memberof IServiceConfigDto
     */
    service_ids?: Set<number>;
    /**
     * 
     * @type {Array<IServiceLiteWithCategoryTypeDto>}
     * @memberof IServiceConfigDto
     */
    services?: Array<IServiceLiteWithCategoryTypeDto>;
    /**
     * 
     * @type {number}
     * @memberof IServiceConfigDto
     */
    processing_tier_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IServiceConfigDto
     */
    health_plan_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IServiceConfigDto
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof IServiceConfigDto
     */
    claim_value?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IServiceConfigDto
     */
    is_applied_deductible?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IServiceConfigDto
     */
    payment_type?: IServiceConfigDtoPaymentTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IServiceConfigDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IServiceConfigDto
     */
    organization_path?: string;
    /**
     * 
     * @type {Array<IPaymentRuleDto>}
     * @memberof IServiceConfigDto
     */
    payment_rules?: Array<IPaymentRuleDto>;
}

/**
* @export
* @enum {string}
*/
export enum IServiceConfigDtoPaymentTypeEnum {
    AMOUNT = 'AMOUNT',
    PERCENTAGE = 'PERCENTAGE'
}


/**
 * Check if a given object implements the IServiceConfigDto interface.
 */
export function instanceOfIServiceConfigDto(value: object): value is IServiceConfigDto {
    return true;
}

export function IServiceConfigDtoFromJSON(json: any): IServiceConfigDto {
    return IServiceConfigDtoFromJSONTyped(json, false);
}

export function IServiceConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IServiceConfigDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'service_id': json['service_id'] == null ? undefined : json['service_id'],
        'service': json['service'] == null ? undefined : IServiceLiteWithCategoryTypeDtoFromJSON(json['service']),
        'service_ids': json['service_ids'] == null ? undefined : new Set(json['service_ids']),
        'services': json['services'] == null ? undefined : ((json['services'] as Array<any>).map(IServiceLiteWithCategoryTypeDtoFromJSON)),
        'processing_tier_id': json['processing_tier_id'] == null ? undefined : json['processing_tier_id'],
        'health_plan_id': json['health_plan_id'] == null ? undefined : json['health_plan_id'],
        'description': json['description'] == null ? undefined : json['description'],
        'claim_value': json['claim_value'] == null ? undefined : json['claim_value'],
        'is_applied_deductible': json['is_applied_deductible'] == null ? undefined : json['is_applied_deductible'],
        'payment_type': json['payment_type'] == null ? undefined : json['payment_type'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'payment_rules': json['payment_rules'] == null ? undefined : ((json['payment_rules'] as Array<any>).map(IPaymentRuleDtoFromJSON)),
    };
}

export function IServiceConfigDtoToJSON(json: any): IServiceConfigDto {
    return IServiceConfigDtoToJSONTyped(json, false);
}

export function IServiceConfigDtoToJSONTyped(value?: IServiceConfigDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'service_id': value['service_id'],
        'service': IServiceLiteWithCategoryTypeDtoToJSON(value['service']),
        'service_ids': value['service_ids'] == null ? undefined : Array.from(value['service_ids'] as Set<any>),
        'services': value['services'] == null ? undefined : ((value['services'] as Array<any>).map(IServiceLiteWithCategoryTypeDtoToJSON)),
        'processing_tier_id': value['processing_tier_id'],
        'health_plan_id': value['health_plan_id'],
        'description': value['description'],
        'claim_value': value['claim_value'],
        'is_applied_deductible': value['is_applied_deductible'],
        'payment_type': value['payment_type'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'payment_rules': value['payment_rules'] == null ? undefined : ((value['payment_rules'] as Array<any>).map(IPaymentRuleDtoToJSON)),
    };
}

